module.exports = __webpack_public_path__ + "static/media/mis_dashboard.23f216ab.svg";